module.exports = __webpack_public_path__ + "static/media/mx.e71790bb.webp";